var ADDON_ID="storybook/outline",PARAM_KEY="outline";

export { ADDON_ID, PARAM_KEY };
